import React from 'react';
import './LoaderCustom.css'; // Assuming the CSS is in this file

function LoaderCustom() {
    return <div className="loader-custom"></div>;
}

export default LoaderCustom;
